// @flow

import type { DashboardState } from "./types";

export const initialState: DashboardState = {
  error: null,
  requestsInProgress: 0,
  absenceNow: {
    departmentOverview: [],
    reasonOverview: [],
    trendActivity: [],
    effectiveParameters: null,
  },
  overview: {
    notificationReviews: [],
    statistics: [],
    today: [],
    targetedReasons: null,
  },
  activityFeed: [],
  firstcareIndexPageStatistic: {
    aboveAverageMeasures: 0,
    absenceLevels: [],
    absenceReasons: [],
    ageGroups: [],
    belowAverageMeasures: 0,
    equalToAverageMeasures: 0,
    genders: [],
    staffGroups: [],
    totalAverages: 0,
    weekdays: [],
  },
  absenceNotes: [],
  hierarchyBreakdown: [],
};

export default initialState;
